<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Desktop') },
                { title: $t('OSInfo') },
                { title: $t('BrowserName') },
                { title: $t('DeviceName') },
                { title: $t('IP') },
                { title: $t('CreateOn'), sort: 'CreateOn' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 16%">
                  <span v-if="row.isDesktop == true">
                    <i
                      class="
                        vs-icon
                        notranslate
                        icon-scale
                        vs-button--icon
                        feather
                        icon-check
                        null
                      "
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      class="
                        vs-icon
                        notranslate
                        icon-scale
                        vs-button--icon
                        feather
                        icon-x
                        null
                      "
                    ></i>
                  </span>
                </td>
                <td style="width: 16%">
                  {{ row.osInfo }}
                </td>
                <td style="width: 16%">
                  {{ row.browserName }}
                </td>
                <td style="width: 16%">
                  {{ row.deviceName }}
                </td>
                <td style="width: 16%">
                  {{ row.ip }}
                </td>
                <td style="width: 16%; direction: ltr">
                   {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name:"Content_management_WebsiteVisitors_Index",
  components: {
    DataGrid,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "CMS/api/VisitorsQuery",
      },
      gridSearchData: {},
    };
  },
};
</script>



